<template>
    <v-slide-y-transition mode="out-in">
        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <!-- mini statistic start -->
            <v-flex v-for="(item) in apps" lg2 sm3 xs6>              
              <v-card @click.native="init(item.key)" style="cursor: pointer">
                <v-card-text class="pa-0">
                  <v-container class="pa-0">
                    <div class="layout row ma-0">
                      <div class="sm5 xs5 flex">
                        <div class="layout column ma-0 justify-center align-center">
                          <v-icon size="56px" :color="item.color">{{item.icon}}</v-icon>
                        </div>
                      </div>
                      <div class="sm7 xs7 flex text-sm-center py-3 white--text" :class="item.color">
                        <div class="headline">{{item.headline}}</div>
                        <span class="caption">{{item.caption}}</span>
                      </div>
                    </div>
                  </v-container>                  
                </v-card-text>
              </v-card>                                
            </v-flex>            
          </v-layout>                  
        </v-container>
    </v-slide-y-transition>
</template>

<script>  
import ls from '@/util/localStorage'  
  
export default { 
  data: () => ({
    apps : [
      { 
        key:'master',
        color:'blue-grey',
        icon:'dns',
        headline: 'master',
        caption:'enterprise'
      },  
      { 
        key:'fico',
        color:'blue',
        icon:'local_atm',
        headline: 'fico',
        caption:'enterprise'
      },
      { 
        key:'inventory',
        color:'cyan',
        icon:'domain',
        headline: 'inventory',
        caption:'enterprise'
      },
      { 
        key:'antrian',
        color:'pink',
        icon:'people',
        headline: 'antrian',
        caption:'sim rs'
      }
    ],       
  }),
  created () {
    //console.log(this.$router.options);

    //this.$router.options.routes = reroute(routeAll, 'fico');

    //console.log(this.$router);
  },
  methods:{
    init(key){
      ls.set('apps',key);
      this.$router.go(0);
    }
  }
    
}
  
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
